import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const API_BASE_URL = process.env.NEXT_PUBLIC_API_BASE_URL;

export interface Settings {
  _id: string;
  enableHomepagePopup: boolean;
  popupTitle?: string;
  popupDescription?: string;
  popupDelay?: number;
  popupImage?: string;
  logo?: string;
  siteName?: string;
  footerDescription?: string;
  sliderImages?: string[];
  privacyPolicy?: {
    title: string;
    description: string;
  };
  returnPolicy?: {
    title: string;
    description: string;
  };
  deliveryCharge?: number;
  mobileMfs?: {
    bKash?: { bKashLogo?: string; bKashNumber?: string };
    nagad?: { nagadLogo?: string; nagadNumber?: string };
    rocket?: { rocketLogo?: string; rocketNumber?: string };
    upay?: { upayLogo?: string; upayNumber?: string };
  };
  contactAndSocial?: {
    address?: string;
    email?: string;
    phone?: string;
    facebookUrl?: string;
    instagramUrl?: string;
    tiktokUrl?: string;
    youtubeUrl?: string;
  };
  newsletter?: {
    title?: string;
    description?: string;
  };
  copyrightText?: string;
}

export interface SettingsResponse {
  success: boolean;
  message: string;
  data: Settings;
}

export const settingsApi = createApi({
  reducerPath: "settingsApi",
  baseQuery: fetchBaseQuery({
    baseUrl: API_BASE_URL,
    prepareHeaders: (headers) => {
      const token = localStorage.getItem("accessToken");
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      return headers;
    },
    credentials: "include",
  }),
  tagTypes: ["Settings"],
  endpoints: (builder) => ({
    getSettings: builder.query<SettingsResponse, void>({
      query: () => "/settings",
      providesTags: ["Settings"],
    }),
    updateSettings: builder.mutation<SettingsResponse, { data: FormData }>({
      query: ({ data }) => ({
        url: "/settings",
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: ["Settings"],
    }),
  }),
});

export const { useGetSettingsQuery, useUpdateSettingsMutation } = settingsApi;
